/**
 * 组件库配置
 */
const config = {
  /** 日志配置 */
  log: {
    /** 是否打印输出 */
    isPrint: false,
  },
  cookie: {
    /** 默认30天过期 */
    maxAgeMinute: 43200,
  },
};

export { config };
